import React from 'react';
import ExpandSection from 'src/components/ExpandSection';
import { Poppins } from 'src/common';

export const AuditSection: React.FC = () => {
  return (
    <ExpandSection title="AUDIT" defaultOpen={false} sectionId="report_centre_audit">
      <Poppins px={14} color="cflowerBlue">
        TODO
      </Poppins>
    </ExpandSection>
  );
};
